var dropdown = function() {
	var options = {
		openClass: 'open'
	};

	var _dropdown = null;
	var _internal = {};

	var init = function(element) {
		_dropdown = $(element);

		$(document).on('click', _internal.documentClick);
	};

	_internal.documentClick = function(e) {

		if (_dropdown.is(e.target) || _dropdown.has(e.target).length > 0)
		{
			_dropdown.toggleClass(options.openClass);
		} else {
			_dropdown.removeClass(options.openClass);
		}
	};

	return {
		init: init,
		_internal: _internal
	};
};

$(function() {
	$('.dropdown').each(function() {
		var dd = new dropdown();
		dd.init(this);
	});
});
